import { connect } from 'react-redux';
import { getCurrentBackgroundId, getIsBackgroundsPopupOpen, } from '../../../DeviationBackground/redux/selectors';
import { initializeBackgrounds, showBackgroundPicker, } from '../../../DeviationBackground/redux/actions';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return {
        currentBackgroundId: getCurrentBackgroundId(state, deviation),
        isBackgroundsPopupOpen: getIsBackgroundsPopupOpen(state),
    };
};
var mapDispatchToProps = {
    onInitialize: initializeBackgrounds,
    showBackgroundPicker: showBackgroundPicker,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=EditBackgroundButton.container.js.map